import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { api } from '../utils/api';
import { toast } from './Toast/Toast';
import { messages } from '../utils/messages';
import styled from 'styled-components';

const CancelContainer = styled.div`
  max-width: 600px;
  margin: 100px auto;
  padding: 40px;
  text-align: center;
  background: white;
  border-radius: 20px;
  box-shadow: 0 10px 30px rgba(0,0,0,0.1);
`;

const CancelButton = styled.button`
  background: #ef4444;
  color: white;
  border: none;
  padding: 12px 30px;
  border-radius: 50px;
  font-size: 16px;
  cursor: pointer;
  margin-top: 20px;
  &:disabled { background: #9ca3af; cursor: not-allowed; }
`;

const BackButton = styled.button`
  background: #3b82f6;
  color: white;
  border: none;
  padding: 12px 30px;
  border-radius: 50px;
  cursor: pointer;
  margin-top: 20px;
  margin-left: 10px;
`;

const CancelMessage = styled.div`
  background: ${props => props.type === 'error' ? '#fef2f2' : '#fef9c3'};
  color: ${props => props.type === 'error' ? '#dc2626' : '#854d0e'};
  padding: 15px;
  border-radius: 10px;
  margin: 20px 0;
`;

const CancelBooking = () => {
  const { bookingId } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [booking, setBooking] = useState(null);
  const [cancelling, setCancelling] = useState(false);
  const [cancelError, setCancelError] = useState(null);

  useEffect(() => {
    const fetchBooking = async () => {
      try {
        const data = await api.getBookingInfo(bookingId);
        if (data.success) setBooking(data.booking);
        else toast.error(messages.booking.bookingNotFound);
      } catch (error) {
        toast.error(messages.general.error);
      } finally {
        setLoading(false);
      }
    };
    fetchBooking();
  }, [bookingId]);

  const handleCancel = async () => {
    if (!confirm(messages.booking.cancelConfirm)) return;
    setCancelling(true);
    setCancelError(null);
    try {
      const data = await api.cancelBooking(bookingId);
      if (data.success) {
        toast.success(messages.booking.cancelSuccess);
        setTimeout(() => navigate('/'), 2000);
      } else {
        setCancelError(data.message);
        toast.error(data.message);
      }
    } catch (error) {
      const errorMsg = error.response?.data?.message || messages.booking.cancelError;
      setCancelError(errorMsg);
      toast.error(errorMsg);
    } finally {
      setCancelling(false);
    }
  };

  if (loading) return <CancelContainer>{messages.general.loading}</CancelContainer>;
  if (!booking) return (
    <CancelContainer>
      <h2>❌ {messages.booking.bookingNotFound}</h2>
      <BackButton onClick={() => navigate('/')}>На главную</BackButton>
    </CancelContainer>
  );

  const timesStr = Array.isArray(booking.timeSlots) ? booking.timeSlots.join(', ') : booking.timeSlots;
  const courtName = booking.court === 'court1' ? 'Корт №1' : 'Корт №2';

  return (
    <CancelContainer>
      <h2>📅 Информация о записи</h2>
      <p><strong>Дата:</strong> {booking.date}</p>
      <p><strong>Время:</strong> {timesStr}</p>
      <p><strong>Корт:</strong> {courtName}</p>
      <p><strong>Имя:</strong> {booking.name}</p>
      {cancelError && <CancelMessage type="error">⚠️ {cancelError}</CancelMessage>}
      <CancelMessage type="info">⏰ Отменить запись можно не менее чем за 12 часов до начала тренировки.</CancelMessage>
      <CancelButton onClick={handleCancel} disabled={cancelling}>
        {cancelling ? messages.general.loading : '❌ Отменить запись'}
      </CancelButton>
      <BackButton onClick={() => navigate('/')}>На главную</BackButton>
    </CancelContainer>
  );
};

export default CancelBooking;